<p-datepicker
    [id]="id()"
    [ngModel]="selectedDate()"

    [minDate]="minDate()"
    [maxDate]="maxDate()"
    [disabledDates]="disabledDates()"

    [placeholder]="placeholder()"
    [showClear]="true"
    
    [disabled]="disabled()"
    [invalid]="isInvalid()"

    
    [showButtonBar]="true"
    [showIcon]="disabled() ? false : true"
    [appendTo]="'body'"
    
    (onBlur)="blur.emit()"
    (ngModelChange)="handleChange($event)"

    fluid
>
</p-datepicker>